import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import RHFTextField from './rhf-text-field';

export default function CenteredLabelTextField({ required, ...props }) {
  const {
    watch,
    formState: { errors },
  } = useFormContext();
  const value = watch(props.name);
  const error = errors[props.name];

  return (
    <RHFTextField
      {...props}
      required={required} // Pass required explicitly here to TextField
      error={!!error}
      helperText={error ? error.message : props.helperText}
      InputLabelProps={{
        shrink: Boolean(value) || !!error,
        className: 'centered-label',
        required, // can keep here, but main required must be direct prop
      }}
      sx={{
        position: 'relative',
        '& .centered-label': {
          position: 'absolute',
          top: value || error ? 0 : '50%',
          left: value || error ? 14 : '50%',
          transform: value || error ? 'translate(0, -50%) scale(0.75)' : 'translate(-50%, -50%)',
          pointerEvents: 'none',
          transition: 'all 0.2s ease',
          backgroundColor: value || error ? '#fff' : 'transparent',
          padding: value || error ? '0 6px' : '0',
        },
        '& input': {
          padding: '12px 20px',
        },
      }}
      placeholder=" "
    />
  );
}

CenteredLabelTextField.propTypes = {
  helperText: PropTypes.object,
  name: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.bool,
  size: PropTypes.string,
  shrink: PropTypes.bool,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
};
